module.exports = __webpack_public_path__ + "static/narozhny-779278398a0b7d6dd8fd93f410ab7579.png";